import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, ArrowUpRight } from 'lucide-react';

const PublicFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1D1D1B] text-white" data-testid="public-footer">
      {/* Gold accent line */}
      <div 
        className="h-1"
        style={{ background: 'linear-gradient(135deg, #FFD537 0%, #F9B438 100%)' }}
      />
      
      <div className="container-app py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src="/logo-pey.png" 
                alt="PEY Consultants" 
                className="h-12 object-contain brightness-0 invert"
              />
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Consortium d'ingénieurs spécialisé dans la gestion durable des eaux de ruissellement, l'hydrologie urbaine, la modélisation hydraulique et les infrastructures urbaines.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6 flex items-center gap-2">
              <span 
                className="w-8 h-0.5 rounded-full"
                style={{ background: 'linear-gradient(135deg, #FFD537 0%, #F9B438 100%)' }}
              />
              Navigation
            </h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/60 text-sm hover:text-[#FFD537] transition-colors">Accueil</Link></li>
              <li><Link to="/a-propos" className="text-white/60 text-sm hover:text-[#FFD537] transition-colors">À propos</Link></li>
              <li><Link to="/services" className="text-white/60 text-sm hover:text-[#FFD537] transition-colors">Notre expertise</Link></li>
              <li><Link to="/projets" className="text-white/60 text-sm hover:text-[#FFD537] transition-colors">Nos projets</Link></li>
              <li><Link to="/contact" className="text-white/60 text-sm hover:text-[#FFD537] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Expertise */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6 flex items-center gap-2">
              <span 
                className="w-8 h-0.5 rounded-full"
                style={{ background: 'linear-gradient(135deg, #FFD537 0%, #F9B438 100%)' }}
              />
              Expertise
            </h4>
            <ul className="space-y-3">
              <li className="text-white/60 text-sm">Gestion des eaux</li>
              <li className="text-white/60 text-sm">Gestion des actifs</li>
              <li className="text-white/60 text-sm">Conception d'infrastructures</li>
              <li className="text-white/60 text-sm">Aménagement paysager</li>
              <li className="text-white/60 text-sm">Normes et règlements</li>
              <li className="text-white/60 text-sm">Gestion de projet</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6 flex items-center gap-2">
              <span 
                className="w-8 h-0.5 rounded-full"
                style={{ background: 'linear-gradient(135deg, #FFD537 0%, #F9B438 100%)' }}
              />
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FFD537] mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">
                  Montréal, Québec<br />
                  Canada
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#FFD537] flex-shrink-0" />
                <a href="mailto:info@peyconsultants.ca" className="text-white/60 text-sm hover:text-[#FFD537] transition-colors">
                  info@peyconsultants.ca
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-white/40 text-sm">
              © {currentYear} PEY Consultants inc. Tous droits réservés.
            </p>
            <p className="text-white/30 text-xs mt-1">
              Développé par{' '}
              <a 
                href="https://www.dgsolutionscanada.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#FFD537]/60 hover:text-[#FFD537] transition-colors"
              >
                DG Solutions
              </a>
            </p>
          </div>
          <div className="flex gap-6">
            <Link 
              to="/connexion" 
              className="flex items-center gap-1 text-sm text-white/60 hover:text-[#FFD537] transition-colors group"
            >
              Espace client
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
